<template>
    <p-modal v-if="display">
        <div slot="content">
            <div class="title">
                取消配對
            </div>
            <div class="subtitle">
                取消配對將無法繼續進行任務
            </div>
        </div>
        <div slot="buttons" class="buttons">
            <div class="cancel button" @click="onResult(false)">
                取消
            </div>
            <div class="confirm button" @click="onResult(true)">
                我要取消
            </div>
        </div>
    </p-modal>
</template>

<script>
    import Modal from './Modal';

    export default {
        name: 'RevokeOrderModal',
        components: {
            'p-modal': Modal
        },
        data() {
            return {
                display: false,
            };
        },
        methods: {
            onResult(result) {
                this.display = false;

                if (result) {
                    this.$emit('onConfirm');
                } else {
                    this.$emit('onCancel');
                }
            },
            show() {
                this.display = true;
            }
        }
    };
</script>

<style lang="scss" scoped>
    .title {
        color: rgba(0,0,0,1);
        font-family: "PingFang TC";
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        text-align: center;
    }

    .subtitle {
        color: rgba(120,120,120,1);
        font-family: "PingFang TC";
        font-size: 12px;
        line-height: 17px;
        text-align: center;
        margin-top: 5px;
    }

    .buttons {
        display: flex;

        .button {
            width: calc(50% - 1px);
            font-family: "PingFang TC";
            font-size: 16px;
            line-height: 22px;
            text-align: center;
            padding: 12px 0;

            &.cancel {
                color: rgba(155,155,155,1);
            }

            &.confirm {
                color: rgba(244,67,54,1);
            }

            &:first-child {
                border-right: solid 1px rgba(221,221,221,1);
            }
        }
    }
</style>
